import React from 'react'

import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

// Font Awesome icons.
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SFB_Logo from '../images/SFB_Logo.png'

function RegistrationModal({ children, isOpen = false, size = 'lg', titleContent = '', footerContent, className = 'bg-darker', headerLabelClassName = '', footerClassName = '', closeModal = () => null }) {
  const modalTitleId = 'registration-modal-title';

  return (
    <Modal
        backdrop
        size={size}
        isOpen={isOpen}
        labelledBy={modalTitleId}
        aria-modal="true"
        contentClassName={`rounded-4 shadow ${className}`}
    >
        <div className="d-flex justify-content-between align-items-center px-3 py-2 z-1 border-0 border-bottom border-primary-orange-subtle modal-header rounded-top-4 surface-elevated" >
            <div className="modal-brand-slot">
                <img fetchpriority="high" src={SFB_Logo} alt="Spitface Battles Logo" width="48" height="48" loading="lazy" decoding="async" className="img-fluid rounded-circle shadow-xs" />
            </div>
            
            <h1 id={modalTitleId} className={`text-center fs-3 m-0 ${headerLabelClassName}`}>
                <div className="lh-tight text-uppercase mb-0 site-title anton-regular fw-normal">
                    <span className="text-primary-orange">Spitface</span>
                    <span className="fs-6 text-white">Battles</span>
                </div>
            </h1>

            <Button outline color="transparent" aria-label="Close dialog" onClick={closeModal} className="border-0 p-1">
                <FontAwesomeIcon icon={faTimes} size="2x" className="text-danger" />
            </Button>
        </div>

        <ModalBody className="p-4 bg-darker alert-body">
            {children}
        </ModalBody>

        <ModalFooter className={`py-2 px-3 rounded-bottom-4 border-0 border-top border-primary-orange-subtle surface-elevated ${footerClassName}`}>
            {footerContent || (
                <Button
                    outline
                    size="sm"
                    color="primary"
                    onClick={closeModal}
                    className="fw-semibold border-2 px-4"
                >
                    Done
                </Button>
            )}
        </ModalFooter>
    </Modal>
  )
}

export default RegistrationModal
